import { MappedImage, ModalWrapper, VimeoFrame } from "../../utils/fw"
import { TimeSwitch } from "../../utils/fw"
import { triggerGamificationRule } from "../../utils/fw"


const { "Event ID": eventId, "Registrant ID": regId } = window.dataLayer[0]

export default {
	background: "https://assets.swoogo.com/uploads/full/5403547-6838c7d68cd8d.jpg",
	links: [
		{
			height: "23.5%",
			label: "Play pacman!",
			left: "0%",
			top: "38%",
			width: "9.2%",
			onClick: () => {
				document.getElementById("lounge-pacman").click()
				if (
					new Date() > new Date("2021-10-23T00:00+01:00")
					&& new Date() < new Date("2021-10-26T07:00+01:00")
				) {
					triggerGamificationRule("lounge-pacman")
				} else if (
					new Date() > new Date("2021-10-26T07:00+01:00")
					&& new Date() < new Date("2021-10-27T07:00+01:00")
				) {
					triggerGamificationRule("lounge-pacman-2")
				} else if (
					new Date() > new Date("2021-10-27T07:00+01:00")
					&& new Date() < new Date("2021-10-30T07:00+01:00")
				) {
					triggerGamificationRule("lounge-pacman-2")
				}
			},
		},
		{
			height: "23.5%",
			label: "Play connect 4!",
			left: "10.4%",
			top: "38%",
			width: "10.2%",
			onClick: () => {
				document.getElementById("lounge-connect-4").click()
				if (
					new Date() > new Date("2021-10-23T00:00+01:00")
					&& new Date() < new Date("2021-10-26T07:00+01:00")
				) {
					triggerGamificationRule("lounge-connect-4")
				} else if (
					new Date() > new Date("2021-10-26T07:00+01:00")
					&& new Date() < new Date("2021-10-27T07:00+01:00")
				) {
					triggerGamificationRule("lounge-connect-4-2")
				} else if (
					new Date() > new Date("2021-10-27T07:00+01:00")
					&& new Date() < new Date("2021-10-30T07:00+01:00")
				) {
					triggerGamificationRule("lounge-connect-4-3")
				}
			},
		},
		{
			height: "11.5%",
			label: "Play memory game!",
			left: "1%",
			top: "60.5%",
			width: "12.2%",
			onClick: () => {
				document.getElementById("lounge-memory").click()
				if (
					new Date() > new Date("2021-10-23T00:00+01:00")
					&& new Date() < new Date("2021-10-26T07:00+01:00")
				) {
					triggerGamificationRule("lounge-memory")
				} else if (
					new Date() > new Date("2021-10-26T07:00+01:00")
					&& new Date() < new Date("2021-10-27T07:00+01:00")
				) {
					triggerGamificationRule("lounge-memory-2")
				} else if (
					new Date() > new Date("2021-10-27T07:00+01:00")
					&& new Date() < new Date("2021-10-30T07:00+01:00")
				) {
					triggerGamificationRule("lounge-memory-3")
				}
			},
		},
		{
			onClick: () => {
				if (
					new Date() < new Date("2021-10-26T07:00+01:00")
				) {
					triggerGamificationRule("lounge-magic-1")
				} else if (
					new Date() > new Date("2021-10-26T07:00+01:00")
					&& new Date() < new Date("2021-10-27T07:00+01:00")
				) {
					triggerGamificationRule("lounge-magic-2")
				} else if (
					new Date() > new Date("2021-10-27T07:00+01:00")
				) {
					triggerGamificationRule("lounge-magic-3")
				}
			},
			label: "Watch our magician - new tricks daily!",
			width: "7.2%",
			height: "24.5%",
			left: "21%",
			top: "43%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-22T00:00+01:00",
						ends: "2021-10-26T07:00+01:00",
						content: <VimeoFrame vidId="629290982?h=0c5e19d11a&autoplay=1" />,
					},
					{
						starts: "2021-10-26T07:00+01:00",
						ends: "2021-10-27T07:00+01:00",
						content: <VimeoFrame vidId="630006253?h=693050e4ec&autoplay=1" />,
					},
					{
						starts: "2021-10-27T07:00+01:00",
						ends: "2050-10-30T07:00+01:00",
						content: <VimeoFrame vidId="629289240?h=fa5793e222&autoplay=1" />,
					},
				]}
			</TimeSwitch>
		},
		{
			height: "23.2%",
			label: "The top participators in Digital 2021",
			left: "29%",
			top: "30.2%",
			width: "20.4%",
			modal: <ModalWrapper>
				{
					window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes"
						? <iframe style="width: 30vw; height: 35vh; border: none;" src={`https://sponsor-gamification.herokuapp.com/leaderboard?eventId=${eventId}&registrantId=${regId}&swoogoAccess=false`} />
						: <div style="display: flex; flex-direction: column; justify-content: space-around; width: 650px; height: 130px; color: white;">
							<h1 style="font-size: 28px; margin: 0;">Want to participate in the leaderboard competition?</h1>
							<p style="font-size: 16px;">You are not opted-in to the leaderboard gamification feature. To opt-in, please modify your registration <a href="https://isfcongress.tkeventsregistration.com/digital2021">here.</a>
							</p>
						</div>
				}
			</ModalWrapper>
		},
		{
			height: "23.6%",
			href: "/sponsor-theatre",
			label: "Sponsor Theatre",
			left: "50.4%",
			top: "30.1%",
			width: "20.4%",
		},
		{
			label: "Watch our artist draw today's keynotes",
			width: "10.1%",
			height: "11.9%",
			left: "67.8%",
			top: "54.4%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-23T00:00",
						ends: "2021-10-26T07:00+01:00",
						content: <VimeoFrame
							vidId="630926239?h=c3628bc3ac&autoplay=1"
						></VimeoFrame>
					},
					{
						starts: "2021-10-26T07:00+01:00",
						ends: "2021-10-27T07:00+01:00",
						content: <VimeoFrame
							vidId="630927258?h=69b9e6bdb8&autoplay=1"
						></VimeoFrame>
					},
					{
						starts: "2021-10-27T07:00+01:00",
						ends: "2030-10-30T07:00+01:00",
						content: <VimeoFrame
							vidId="630925933?h=64128e71da&autoplay=1"
						></VimeoFrame>
					},
				]}
			</TimeSwitch>,
		},
		{
			height: "17.5%",
			label: "Try out today's recipes here",
			left: "78.3%",
			top: "48%",
			width: "11.3%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-23T00:00+01:00",
						ends: "2021-10-26T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1405180-6165d9755c353.png"
							links={[
								{
									gameRule: "lounge-chef-day",
									height: "5.1%",
									label: "Video - Dish of the Day",
									left: "30%",
									modal: <VimeoFrame
										vidId="629296259?h=e64bc66de9&autoplay=1"
									/>,
									top: "49.6%",
									width: "40.1%",
								},
								{
									height: "5.6%",
									href: "https://assets.swoogo.com/uploads/1405214-6165db567b4d8.pdf",
									isExternal: true,
									label: "Try out today's recipe here!",
									left: "30%",
									target: "_blank",
									top: "55.7%",
									width: "40.1%",
								},
							]}
						/>,
					},
					{
						starts: "2021-10-26T07:00+01:00",
						ends: "2021-10-27T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1405180-6165d9755c353.png"
							links={[
								{
									gameRule: "lounge-chef-day-2",
									height: "5.1%",
									label: "Video - Dish of the Day",
									left: "30%",
									modal: <VimeoFrame
										vidId="629298235?h=f7b4e8bbaf&autoplay=1"
									/>,
									top: "49.6%",
									width: "40.1%",
								},
								{
									height: "5.6%",
									href: "https://assets.swoogo.com/uploads/1440302-6174989928c30.pdf",
									isExternal: true,
									label: "Try out today's recipe here!",
									left: "30%",
									target: "_blank",
									top: "55.7%",
									width: "40.1%",
								},
							]}
						/>,
					},
					{
						starts: "2021-10-27T07:00+01:00",
						ends: "2021-10-30T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1405180-6165d9755c353.png"
							links={[
								{
									gameRule: "lounge-chef-day-3",
									height: "5.1%",
									label: "Video - Dish of the Day",
									left: "30%",
									modal: <VimeoFrame
										vidId="629293589?h=f1de256de7&autoplay=1"
									/>,
									top: "49.6%",
									width: "40.1%",
								},
								{
									height: "5.6%",
									href: "https://assets.swoogo.com/uploads/1440303-617498ad1a701.pdf",
									isExternal: true,
									label: "Try out today's recipe here!",
									left: "30%",
									target: "_blank",
									top: "55.7%",
									width: "40.1%",
								},
							]}
						/>,
					},
				]}
			</TimeSwitch>,
			modalOverrides: {
				dismissStyle: {
					height: "65px",
					right: "27.5%",
					top: "15%",
					width: "65px",
				},
			},
		},
		{
			height: "17.5%",
			label: "Join a yoga session and relax! New sessions daily",
			left: "89.3%",
			top: "52%",
			width: "10.3%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-23T00:00+01:00",
						ends: "2021-10-26T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1411791-6168f90091b25.png"
							links={[
								{
									label: "Introduction",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "37.4%",
									modal: <VimeoFrame
										vidId="629931972?h=94bb084b70&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-5",
									label: "5-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "43.9%",
									modal: <VimeoFrame
										vidId="629930698?h=5953152d9c&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-10",
									label: "10-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "50.4%",
									modal: <VimeoFrame
										vidId="629313380?h=ab8e681efc&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-20",
									label: "20-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "57%",
									modal: <VimeoFrame
										vidId="629301605?h=83fc4996b0&autoplay=1"
									/>,
								},
								{
									label: "Yoga Disclaimer",
									href: "https://assets.swoogo.com/uploads/1411799-6168fc6a434d7.pdf",
									isExternal: true,
									target: "_blank",
									width: "40.1%",
									height: "5.6%",
									left: "30%",
									top: "63.6%",
								},
							]}
						/>,
					},
					{
						starts: "2021-10-26T07:00+01:00",
						ends: "2021-10-27T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1411791-6168f90091b25.png"
							links={[
								{
									label: "Introduction",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "37.4%",
									modal: <VimeoFrame
										vidId="629931972?h=94bb084b70&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-5-2",
									label: "5-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "43.9%",
									modal: <VimeoFrame
										vidId="629315862?h=6e47265379&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-10-2",
									label: "10-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "50.4%",
									modal: <VimeoFrame
										vidId="629308069?h=3abdc6f5f5&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-20-2",
									label: "20-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "57%",
									modal: <VimeoFrame
										vidId="629310128?h=e596ebfb94&autoplay=1"
									/>,
								},
								{
									label: "Yoga Disclaimer",
									href: "https://assets.swoogo.com/uploads/1411799-6168fc6a434d7.pdf",
									isExternal: true,
									target: "_blank",
									width: "40.1%",
									height: "5.6%",
									left: "30%",
									top: "63.6%",
								},
							]}
						/>,
					},
					{
						starts: "2021-10-27T07:00+01:00",
						ends: "2021-10-30T07:00+01:00",
						content: <MappedImage
							imageURL="https://assets.swoogo.com/uploads/full/1411791-6168f90091b25.png"
							links={[
								{
									label: "Introduction",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "37.4%",
									modal: <VimeoFrame
										vidId="629931972?h=94bb084b70&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-5-3",
									label: "5-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "43.9%",
									modal: <VimeoFrame
										vidId="629316986?h=14aba104a7&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-10-3",
									label: "10-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "50.4%",
									modal: <VimeoFrame
										vidId="629318193?h=bc6b60fdc3&autoplay=1"
									/>,
								},
								{
									gameRule: "lounge-yoga-20-3",
									label: "20-minute yoga practice",
									width: "40.4%",
									height: "5.3%",
									left: "29.8%",
									top: "57%",
									modal: <VimeoFrame
										vidId="629305105?h=e14bf1178e&autoplay=1"
									/>,
								},
								{
									label: "Yoga Disclaimer",
									href: "https://assets.swoogo.com/uploads/1411799-6168fc6a434d7.pdf",
									isExternal: true,
									target: "_blank",
									width: "40.1%",
									height: "5.6%",
									left: "30%",
									top: "63.6%",
								},
							]}
						/>,
					},
				]}
			</TimeSwitch>,
			modalOverrides: {
				dismissStyle: {
					height: "55px",
					right: "27%",
					top: "17%",
					width: "55px",
				},
			},
		},
		{
			height: "16.2%",
			href: "/roundtables",
			label: "Roundtable Sessions",
			left: "46.5%",
			top: "57.3%",
			width: "6.8%",
		},
		{
			label: "Digital 2021 Prize List",
			height: "26.9%",
			left: "84.8%",
			top: "69.4%",
			width: "8.1%",
			modal: <MappedImage
				imageURL="https://assets.swoogo.com/uploads/full/1420039-616dbb4ca9054.png"
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "60px",
					right: "7%",
					top: "12%",
					width: "60px",
				},
			},
		}
	],
	name: "lounge",
}
